import { Stack, Typography } from '@mui/material';

import { Button } from '@/components/form/baseInputs/Button';
import { File05Icon } from '@/components/icons/File05Icon';
import { Stars01Icon } from '@/components/icons/Stars01Icon';
import { COLORS } from '@/styles/tokens/colors';

interface NoSummaryViewProps {
  onGenerateAiSummary: () => void;
  onWriteSummary: () => void;
}

export function NoSummaryView({
  onGenerateAiSummary,
  onWriteSummary,
}: NoSummaryViewProps) {
  return (
    <Stack
      height="100%"
      flexGrow={1}
      maxWidth="380px"
      alignSelf="center"
      justifyContent="center"
      alignItems="center"
      spacing={2}
    >
      <Stack spacing={1} alignItems="center">
        <File05Icon size={40} color={COLORS.GRAY[300]} />
        <Typography variant="title-l">No summary yet</Typography>
        <Typography textAlign="center" variant="body-xs">
          Generate a summary of this document automatically with Luminary AI, or
          write your own.
        </Typography>
      </Stack>
      <Stack direction="row" spacing={1}>
        <Button
          variant="primary"
          size="sm"
          startIcon={Stars01Icon}
          onClick={onGenerateAiSummary}
        >
          Generate summary
        </Button>
        <Button variant="secondary" size="sm" onClick={onWriteSummary}>
          Write summary
        </Button>
      </Stack>
    </Stack>
  );
}
